import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import { z } from "zod";

//
// Zod schema for StrategyVersion filters
//
export const filterStrategyVersionSchema = z.object({
  version_id_contains: z
    .preprocess((val: unknown) => {
      const n = Number(val);
      return isNaN(n) ? undefined : n;
    }, z.number())
    .optional(),
  strategy_id_contains: z
    .preprocess((val: unknown) => {
      const n = Number(val);
      return isNaN(n) ? undefined : n;
    }, z.number())
    .optional(),
});

export type FilterStrategyVersionSchema = z.infer<
  typeof filterStrategyVersionSchema
>;

//
// Filter fields configuration
//
export const fields: Field[] = [
  {
    name: "version_id_contains",
    label: "Version",
    type: "input",
    input_type: "number",
  },
  {
    name: "strategy_id_contains",
    label: "Strategy",
    type: "input",
    input_type: "number",
  },
];

export const client = "instit-quantilia";

export function FilterStrategyVersion() {
  return (
    <FilterTable
      client={client}
      schema={filterStrategyVersionSchema}
      tableName="strategy_versions"
      customBuildPath={() => `${client}/strategy_versions`}
      fields={fields}
    />
  );
}
